import React from 'react';
import Accordion from '../../../component/common/Accordion';
import { InfoPopUpModalData } from '../../../utils/pageContent';

const InfoTab = ({ data, title }) => {
  const formattedContent = data?.titleTips.replace(/\n/g, '<br />');
  const formattedContent2 = data?.when.replace(/\n/g, '<br />');
  const formattedContent3 = data?.why.replace(/\n/g, '<br />');
  const tabData = InfoPopUpModalData.infoTabData;

  return (
    <>
      {/* {(data?.title === '' || data?.title === undefined) &&
      (data?.subTitle === '' || data?.subTitle === undefined) &&
      (data?.why === '' || data?.why === undefined) &&
      (data?.when === '' || data?.when === undefined) &&
      (data?.titleTips === '' || data?.titleTips === undefined) &&
      data?.faq?.length === 0 ? (
        <div className="w-full text-center md:h-[calc(100vh-470px)] h-[calc(100vh-555px)] flex items-center justify-center">
          <h5 className="md:text-[20px] text-[18px] font-medium md:mb-[6px]">Data not found</h5>
        </div>
      ) : ( */}
      <>
        <div className="md:mb-[46px] mb-6">
          {data?.title && (
            <h5 className="md:text-[22px] text-[18px] font-medium">
              {title} - {data?.title}
            </h5>
          )}
          <p className="md:text-[18px] text-[14px]">{data?.subTitle}</p>
        </div>
        <div className="flex md:flex-nowrap flex-wrap items-start gap-5">
          <div className="grid grid-cols-1 md:w-1/2 w-full md:gap-[33px] gap-5">
            {data?.why && formattedContent3 && (
              <div className="border-[1.5px] dark:border-shoorah-darkBg border-black border-opacity-10 md:p-[18.56px] p-4 md:rounded-[18.56px] rounded-xl h-fit dark:bg-shoorah-darkBgTabColor">
                <h6 className="font-medium md:text-[18.56px] text-[18px] text-black dark:text-shoorah-darkBg mb-[10px]">
                  {tabData.whyText}
                </h6>
                <p
                  className="text-[#606060] dark:text-shoorah-darkBg text-[14px]"
                  dangerouslySetInnerHTML={{ __html: formattedContent3 }}
                ></p>
              </div>
            )}
            {data?.when && formattedContent2 && (
              <div className="border-[1.5px] dark:border-shoorah-darkBg border-black border-opacity-10 md:p-[18.56px] p-4 md:rounded-[18.56px] rounded-xl h-fit dark:bg-shoorah-darkBgTabColor">
                <h6 className="font-medium md:text-[18.56px] text-[18px] text-black dark:text-shoorah-darkBg mb-[10px]">
                  {tabData.whenText}
                </h6>
                <p
                  className="text-[#606060] dark:text-shoorah-darkBg text-[14px]"
                  dangerouslySetInnerHTML={{ __html: formattedContent2 }}
                ></p>
              </div>
            )}
            {data?.titleTips && formattedContent && (
              <div className="border-[1.5px] dark:border-shoorah-darkBg border-black border-opacity-10 md:p-[18.56px] p-4 md:rounded-[18.56px] rounded-xl h-fit dark:bg-shoorah-darkBgTabColor">
                <h6 className="font-medium md:text-[18.56px] text-[18px] text-black dark:text-shoorah-darkBg mb-[10px]">
                  {data?.tipsTitle}
                </h6>
                <p
                  className="text-[#606060] dark:text-shoorah-darkBg text-[14px]"
                  dangerouslySetInnerHTML={{ __html: formattedContent }}
                ></p>
              </div>
            )}
          </div>
          {data?.faq?.length > 0 && (
            <div className="md:w-1/2 w-full border-[1.5px] border-black dark:border-shoorah-darkBg border-opacity-10 md:p-[18.56px] p-4 md:rounded-[18.56px] rounded-xl">
              <h6 className="font-medium md:text-[18.56px] text-[18px] text-black dark:text-shoorah-darkBg mb-[19px]">
                {tabData.faqText}
              </h6>
              <Accordion data={data?.faq} />
            </div>
          )}
        </div>
      </>
      {/* )} */}
    </>
  );
};

export default InfoTab;
